export const getGCPFeaturePath = (nxtFileName: string, values, fields) => {
  let feature = "library-ncms";
  let basePath = "fun-sheet";

  if (fields.feature === "assignments") {
    feature = "assignments-ncms";
    basePath = `assignments/${values.class_id}/course/${values.subject_id}/chapter`;
  } else if (fields.feature === "schedule") {
    feature = "monthly-schedule-ncms";
    basePath = `schedule/${values.class_id}/${values.course_id}`;
  } else if (fields.feature === "term-exams") {
    feature = "term-exams-ncms";
    basePath = `descriptive-exam/${values.class_id}`;
  } else if (fields.feature === "learn") {
    feature = "learn-ncms";
    basePath = `learn/resources/${values.class_id}/${
      values.course_id || "course"
    }/${values.subject_id || "subject"}/${
      values.topic_id || values.chapter_id || "chapter"
    }`;
  } else if (fields.feature === "build-test") {
    feature = "buildtest-ncms";
    basePath = `build-test`;
  } else if (fields.feature === "fun-sheet") {
    feature = "activity-funsheet-ncms";
    basePath = `fun-sheet`;
  } else if (fields.feature === "library") {
    feature = "library-ncms";
    basePath = `fun-sheet`;
  }else if (fields.feature === "miscellaneous") {
    feature = "miscellaneous-ncms";
    basePath = `instructions`;
  } else if (fields.feature === "announcements") {
    feature = "announcement-ncms";
    basePath = `announcements`;
  } else if (fields.feature === "magazine") {
    feature = "activity-magzine-ncms";
    basePath = `magazine`;
  }

  return {
    feature,
    file_name: `${basePath}/${nxtFileName}`,
  };
};

export const gcpHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  // Authorization: `Bearer ${localStorage.getItem("token")}`,
  platform: "web",
  platformv2: "web",
  project: "ncms",
  source: "ncms",
};

export const generateSignedUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/assignment/v1/miscellaneous/generate-signed-urls`;
